module.exports = __webpack_public_path__ + "components/app-promo/static/de/snow-forecast__app-screenshot--2-c02e3344ccb7025f09263ccf0b88586f.jpg";